import { customElement } from '@aurelia/runtime-html';
import * as __au2ViewDef from './preview-buttons.html';
import { EventAggregator } from "aurelia";
import { GlobalDefinition } from "resources/global_definitions";
import { GlobalSelectedObject } from "resources/global_selected_object";
import { FetchHelper } from "resources/services/fetchHelper";
import { InstanceUtility } from "resources/services/instance_utility";
import { SelectedObjectService } from "resources/services/selected-object";
import { VizrepUpdateChecker } from "resources/services/vizrep_update_checker";
import { Class, Port, Relationclass } from "../../../../mmar-global-data-structure";
import { Logger } from "resources/services/logger";

@customElement(__au2ViewDef)
export class PreviewButtons {

    constructor(
        private eventAggregator: EventAggregator,
        private vizrepUpdateChecker: VizrepUpdateChecker,
        private globalObjectInstance: GlobalDefinition,
        private globalSelectedObject: GlobalSelectedObject,
        private fetchHelper: FetchHelper,
        private selectedObjectService: SelectedObjectService,
        private logger: Logger
    ) { }

    async attached() {
        this.eventAggregator.subscribe("updatedGeometryValue", async () => {
            const currentInstance = this.globalObjectInstance.tabContext[0].sceneInstance;
            const object = this.globalObjectInstance.tabContext[0].threeScene.getObjectById(currentInstance.uuid);

            await this.vizrepUpdateChecker.checkForVizRepUpdateForce();
            this.globalSelectedObject.getObject();
        });
    }


    async preview() {
        this.eventAggregator.publish("previewButtonClicked");
    }

    async save() {
        const objectToPatch = this.selectedObjectService.getSelectedObject();
        const type = this.selectedObjectService.type

        if (type === "Class"){
            this.fetchHelper.classesPATCH(objectToPatch.uuid, objectToPatch as unknown as Class).then(() => {
                this.logger.log("Class updated successfully", "info");
            }).catch((error) => {
                this.logger.log("Error updating class:" + objectToPatch.uuid + " with message " + error, "error");
            });
        }
        else if (type === "RelationClass"){
            this.fetchHelper.relationClassesPATCH(objectToPatch.uuid, objectToPatch as unknown as Relationclass).then(() => {
                this.logger.log("Relationclass updated successfully", "info");
            }).catch((error) => {
                this.logger.log("Error updating relationclass:" + objectToPatch.uuid + " with message " + error, "error");
            });
        }
        else if (type === "Port"){
            this.fetchHelper.portsPATCH(objectToPatch.uuid, objectToPatch as unknown as Port).then(() => {
                this.logger.log("Port updated successfully", "info");
            }).catch((error) => {
                this.logger.log("Error updating port:" + objectToPatch.uuid + " with message " + error, "error");
            });
        }
    }
    }
    import { Metadata as $$M } from '@aurelia/metadata';
    import { ExpressionKind as $$EK } from '@aurelia/runtime';
    import { Controller as $$C, CustomElement as $$CE, IHydrationContext as $$IHC } from '@aurelia/runtime-html';

    // @ts-ignore
    const controllers = [];

    // @ts-ignore
    if (module.hot) {

    // @ts-ignore
    module.hot.accept();

    // @ts-ignore
    const hot = module.hot;

    let aurelia = hot.data?.aurelia;

    // @ts-ignore
    document.addEventListener('au-started', (event) => {aurelia= event.detail; });
    const currentClassType = PreviewButtons;

    // @ts-ignore
    const proto = PreviewButtons.prototype

    // @ts-ignore
    const ogCreated = proto ? proto.created : undefined;

    if (proto) {
      // @ts-ignore
      proto.created = function(controller) {
        // @ts-ignore
        ogCreated && ogCreated.call(this, controller);
        controllers.push(controller);
      }
    }

    // @ts-ignore
    hot.dispose(function (data) {
      // @ts-ignore
      data.controllers = controllers;
      data.aurelia = aurelia;
    });

    if (hot.data?.aurelia) {
      const newDefinition = $$CE.getDefinition(currentClassType);
      $$M.define(newDefinition.name, newDefinition, currentClassType);
      $$M.define(newDefinition.name, newDefinition, newDefinition);
      hot.data.aurelia.container.res[$$CE.keyFrom(newDefinition.name)] = newDefinition;

      const previousControllers = hot.data.controllers ?? [];
      if(previousControllers.length === 0) {
        // @ts-ignore
        hot.invalidate?.();
      }

      // @ts-ignore
      previousControllers.forEach(controller => {
        const values = { ...controller.viewModel };
        const hydrationContext = controller.container.get($$IHC)
        const hydrationInst = hydrationContext.instruction;

        const bindableNames = Object.keys(controller.definition.bindables);
        // @ts-ignore
        Object.keys(values).forEach(key => {
          if (bindableNames.includes(key)) {
            return;
          }
          // if there' some bindings that target the existing property
          // @ts-ignore
          const isTargettedByBinding = controller.bindings?.some(y =>
            y.ast?.$kind === $$EK.AccessScope
              && y.ast.name === key && y.targetProperty
          );
          if (!isTargettedByBinding) {
            delete values[key];
          }
        });
        const h = controller.host;
        delete controller._compiledDef;
        controller.viewModel = controller.container.invoke(currentClassType);
        controller.definition = newDefinition;
        Object.assign(controller.viewModel, values);
        if (controller._hydrateCustomElement) {
          controller._hydrateCustomElement(hydrationInst, hydrationContext);
        } else {
          controller.hE(hydrationInst, hydrationContext);
        }
        h.parentNode.replaceChild(controller.host, h);
        controller.hostController = null;
        controller.deactivate(controller, controller.parent ?? null, 0);
        controller.activate(controller, controller.parent ?? null, 0);
      });
    }
  }